module.exports = __webpack_public_path__ + "img/thumb-make-your-great@2x.d3999743.png";